import { Avatar, Badge, Table } from '@iveco-ti/iveco-ds'
import { useTranslation } from 'react-i18next'

import { capitalizeFirstLetter } from '@/common/utils/capitalizeFirstLetter'
import { countryCodeToFlag } from '@/common/utils/countryCodeToFlag'
import { getDisplayName } from '@/common/utils/getDisplayName'
import { AccountPaginated } from '../hooks/usePaginateAccounts'
import { AccountActiveActions } from './AccountActiveActions'

type AccountTableRowProps = {
  account: AccountPaginated
}

export function AccountTableRow({ account }: AccountTableRowProps) {
  const { i18n } = useTranslation(['common', 'sso'])

  return (
    <Table.Row hideCheckbox id={account?.id}>
      <Table.Data className="flex gap-3 ">
        <Avatar
          src={countryCodeToFlag(account?.country)}
          name={account?.title}
        />

        <div className="flex flex-col justify-center mb-1">
          <span className="text-base-800 font-medium text-sm">
            {account?.title}
          </span>

          <span className="text-base-400 font-light text-sm">
            {account?.accountKey}
          </span>
        </div>
      </Table.Data>

      <Table.Data className="flex flex-col justify-center">
        <span className="text-base-800 font-medium text-sm">
          {getDisplayName(account?.country || '', i18n.language, 'region')}
        </span>
      </Table.Data>

      <Table.Data className="flex flex-col justify-center">
        <span className="text-base-800 font-medium text-sm">
          {capitalizeFirstLetter(
            getDisplayName(account?.locale || '', i18n.language, 'language'),
          )}
        </span>
      </Table.Data>

      <Table.Data className="flex flex-wrap gap-2">
        {account?.ApplicationAccount?.length === 0 && <span>-</span>}

        {account?.ApplicationAccount?.map((appAcc) => (
          <Badge.Root size="sm" shape="square" key={appAcc.id}>
            {appAcc.Application.title}
          </Badge.Root>
        ))}
      </Table.Data>

      <Table.Data end>
        {account?.isActive ? (
          <AccountActiveActions account={account} />
        ) : (
          <span>-</span>
        )}
      </Table.Data>
    </Table.Row>
  )
}
